// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"26":"143fe3b9","513":"143fe3b9"}[chunkId] + ".css";
};